import { useDispatch, useSelector } from 'react-redux'
import { PermissionArea } from '@pbt/pbt-ui-components'

import DialogNames from '~/constants/DialogNames'
import { fetchTask } from '~/store/actions/tasks'
import { getCRUDByArea } from '~/store/reducers/auth'
import { getTask } from '~/store/reducers/tasks'
import type { Task, TaskTimelineItem } from '~/types'
import useDialog from '~/utils/useDialog'

import { useTaskIsEditable } from './useTaskIsEditable'

export const useTaskCardProps = (
  item: TaskTimelineItem,
  clientId: string,
  patientId: string,
) => {
  const dispatch = useDispatch()
  const hasOneTask = item.entries.length === 1
  const taskId = item.entries[0]

  const firstTask = useSelector(getTask(taskId))
  const permissions = useSelector(getCRUDByArea(PermissionArea.TASK))
  const taskIsEditable = useTaskIsEditable(firstTask)

  const [openTaskDialog] = useDialog(DialogNames.TASK)

  const onEdit = (task: Task) => {
    dispatch(fetchTask(task.id))
    openTaskDialog({ clientId, patientId, taskId: task.id })
  }

  return {
    originBusinessId: hasOneTask ? firstTask?.businessId : undefined,
    title: hasOneTask && firstTask?.name,
    onEdit:
      hasOneTask && permissions.update && firstTask && taskIsEditable
        ? () => onEdit(firstTask)
        : undefined,
  }
}
